const routes = [
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "@/pages/Home/About.vue"),
    meta: {
      title: "About - NutriBit",
      showSearch: true
    }
  }
];

export default routes;
